import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Button, Dialog, Grid, TextField, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { useAuth } from '../../units/auth/AuthProvider';

export const useAdvanceDialog = () => {
    const classes = useStyles();
    const auth = useAuth();
    const [open, setOpen] = useState(false);
    const [inputAdvanceMinutes, setInputAdvanceMinutes] = useState<string>('');
    const [onConfirm, setOnConfirm] = useState<(advanceMinutes: number) => void>(() => () => {});
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    const onReset = () => {
        setInputAdvanceMinutes('');
    };
    useEffect(() => {
        if (open) {
        } else {
            onReset();
        }
    }, [open]);
    return {
        classes,
        auth,
        alert,
        open,
        setOpen,
        inputAdvanceMinutes,
        setInputAdvanceMinutes,
        onConfirm,
        setOnConfirm,
        onOpen,
        onClose,
        onReset,
    };
};

export interface AdvanceDialogProps extends ReturnType<typeof useAdvanceDialog> {}

export const AdvanceDialog = (props: AdvanceDialogProps): React.ReactElement => {
    return (
        <Dialog fullWidth={true} maxWidth={'sm'} open={props.open} onClose={props.onClose}>
            <AppBar position='sticky' className={props.classes.appBar} color='primary'>
                <Toolbar>
                    <Typography style={{ width: '100%', textAlign: 'center' }} variant='h4' component={'div'}>
                        {'批次提前'}
                    </Typography>
                    <Typography style={{ position: 'absolute', right: '0px' }} variant='h4' component={'div'}>
                        <Button color='inherit' onClick={props.onClose}>
                            <Typography variant='h5'>
                                <FontAwesomeIcon icon={faXmark} size='lg' fixedWidth />
                            </Typography>
                        </Button>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Grid container flexDirection={'column'} padding={4}>
                <Grid container item flexDirection={'row'}>
                    <Grid container item flexDirection={'row'} xs={12}>
                        <Grid container item flexDirection={'row'} xs={12}>
                            <TextField
                                value={props.inputAdvanceMinutes}
                                onChange={(e) => {
                                    const newValue = e.target.value.replace(/[\D\.]*/g, '').substring(0, 3);
                                    props.setInputAdvanceMinutes(newValue.length == 0 ? '' : Number(newValue).toString());
                                }}
                                variant='outlined'
                                label={<>{'提前時間(分鐘)'}</>}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} justifyContent={'flex-end'} xs={12}>
                            <Button className={props.classes.buttonRed} style={{ margin: 4, marginTop: 12 }} onClick={props.onClose}>
                                <FontAwesomeIcon icon={faXmark} fixedWidth />
                                {'取消'}
                            </Button>
                            <Button
                                disabled={![Number(props.inputAdvanceMinutes) > 0].every((v) => v)}
                                className={props.classes.buttonCyan}
                                style={{ margin: 4, marginTop: 12 }}
                                onClick={() => {
                                    props.onConfirm(Number(props.inputAdvanceMinutes));
                                }}
                            >
                                <FontAwesomeIcon icon={faCheck} fixedWidth />
                                {'確定'}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};
